import { __awaiter } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel, useAutosizeTextArea } from '@websolutespa/bom-mixer-hooks';
import { useRef } from 'react';
import { useLlm } from '../../../useLlm/useLlm.js';
import { useLlmView } from '../../../useLlm/useLlmView.js';
import style from './page-textarea.module.scss.js';

const PageTextarea = () => {
  const label = useLabel();
  const textAreaRef = useRef(null);
  const app = useLlm(state => state.app);
  const prompt = useLlm(state => state.prompt);
  const streaming = useLlm(state => state.streaming);
  const {
    setPrompt
  } = useLlm(state => state.actions);
  const {
    send
  } = useLlmView(state => state.actions);
  useAutosizeTextArea(textAreaRef.current, prompt);
  const onSubmit = event => __awaiter(void 0, void 0, void 0, function* () {
    event && event.preventDefault();
    if (!prompt) {
      return;
    }
    yield send(prompt, response => {
      // console.log('PagePrompt.onChunk', response.chunks);
    }, response => {
      // console.log('PagePrompt.onEnd', response);
    });
  });
  const onChange = event => {
    var _a;
    const prompt = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value;
    setPrompt(prompt);
  };
  const onKeyDown = event => {
    if (event.code == 'Enter' && !event.shiftKey) {
      onSubmit(event);
    }
  };
  return jsxs(Fragment, {
    children: [jsx("label", {
      className: getClassNames(style.label),
      htmlFor: "llm-page-prompt__textarea",
      children: label('llm.prompt')
    }), jsx("textarea", {
      className: getClassNames(style.textarea, '-textarea'),
      ref: textAreaRef,
      id: "llm-page-prompt__textarea",
      name: "prompt",
      placeholder: app === null || app === void 0 ? void 0 : app.contents.promptPlaceholder,
      value: prompt,
      rows: 1,
      "aria-disabled": streaming,
      onKeyDown: onKeyDown,
      onChange: onChange
    })]
  });
};

export { PageTextarea };
//# sourceMappingURL=page-textarea.js.map
